import React, { useState, useEffect } from "react";
import NutritionDistribution from "./NutritionDistribution";
import TopList from "./TopList";
import "./NutrientReportStyles.css";

const downArrow = String.fromCharCode(9660);
const upArrow = String.fromCharCode(9654);

const NutritionReport = ({ list }) => {
  const [nutritionAvailable, setNutritionAvailable] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const checkAvailability = () => {
    list.forEach((item) => {
      if (item.nutrients) {
        setNutritionAvailable(true);
      }
    });
  };

  useEffect(() => {
    checkAvailability();
  }, []);

  return (
    <div id="nutrientReport">
      <div
        id="nutritionTitleRow"
        onClick={() => nutritionAvailable && setExpanded(!expanded)}
      >
        <h4 id="nutritionTitle">Nutrition</h4>
        {nutritionAvailable ? (
          expanded ? (
            downArrow
          ) : (
            upArrow
          )
        ) : (
          <p id="noDataText"> No Data</p>
        )}
      </div>
      <div
        id="reportExpandRow"
        style={expanded ? { height: "275px" } : { height: "0px" }}
      >
        {expanded && (
          <React.Fragment>
            <hr className="reportHr" />
            <TopList list={list} />
            <NutritionDistribution list={list} />
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default NutritionReport;
